import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";
import { BarChart3 } from "lucide-react";

export const SubscriptionChart = () => {
  const [data, setData] = useState([]);
  useEffect(() => { api.get("/admin/subscription-chart").then((r) => setData(r.data)).catch(() => {}); }, []);
  const totals = data.reduce((a, w) => ({ subs: a.subs + w.monthly + w.yearly, codes: a.codes + w.codes }), { subs: 0, codes: 0 });

  return (
    <Card className="rounded-2xl" data-testid="subscription-chart">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 flex-wrap gap-2">
        <CardTitle className="font-heading text-lg flex items-center gap-2"><BarChart3 className="h-5 w-5 text-primary" /> Abbonamenti e codici · ultime 12 settimane</CardTitle>
        <div className="text-xs text-muted-foreground" data-testid="subscription-chart-totals">
          <span className="font-mono-data font-semibold text-foreground">{totals.subs}</span> abbonamenti · <span className="font-mono-data font-semibold text-foreground">{totals.codes}</span> codici usati
        </div>
      </CardHeader>
      <CardContent>
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={data} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
              <XAxis dataKey="label" tick={{ fontSize: 11 }} stroke="hsl(var(--muted-foreground))" />
              <YAxis allowDecimals={false} tick={{ fontSize: 11 }} stroke="hsl(var(--muted-foreground))" />
              <Tooltip contentStyle={{ borderRadius: 12, background: "hsl(var(--card))", border: "1px solid hsl(var(--border))" }}
                labelFormatter={(l) => `Settimana dal ${l}`} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="monthly" name="Mensili" stackId="s" fill="hsl(var(--primary))" radius={[0, 0, 0, 0]} />
              <Bar dataKey="yearly" name="Annuali" stackId="s" fill="hsl(var(--accent))" radius={[6, 6, 0, 0]} />
              <Line type="monotone" dataKey="codes" name="Codici usati" stroke="hsl(var(--foreground))" strokeWidth={2} dot={{ r: 3 }} />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};
